import Nullstack from 'nullstack';
export default function IconMushroomOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mushroom-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5.874 5.89a8.128 8.128 0 0 0 -1.874 5.21a0.9 .9 0 0 0 .9 .9h7.1m4 0h3.1a0.9 .9 0 0 0 .9 -.9c0 -4.474 -3.582 -8.1 -8 -8.1c-1.43 0 -2.774 .38 -3.936 1.047"
  }), "   ", Nullstack.element("path", {
    d: "M10 12v7a2 2 0 1 0 4 0v-5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}